import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';

const RequireAuth = () => {

    const {currentUser, role} = useAuth()
    let location = useLocation();

    return (currentUser && role === "Studio") ? <Outlet /> : <Navigate to="/login" state={{from : location}} replace/> 

};

export default RequireAuth;